const global = window || global
let userAgent = (global.navigator && global.navigator.userAgent) || ''
let ua = userAgent.toLowerCase()

export let isAndroid = function () {
  return ua.indexOf('android') > -1
}
export let isIOS = function () {
  return ua.indexOf('iphone') > -1
}
export let isWinPhone = function () {
  return !!global.navigator.userAgent.match(/windows phone/i)
}
export let isIpad = function () {
  return ua.indexOf('ipad') > -1
}
export let isPhone = function () {
  return isAndroid() || isIOS() || isWinPhone() || isIpad()
}

export let isMobileChrome = function () {
  let chromeInIOS = /iapd|iphone|ipod/.test(ua) && /crios/.test(ua)
  let chromeInAndroid = isAndroid() && /chrome/.test(ua)
  return chromeInIOS || chromeInAndroid
}

export let isFBApp = function () {
  let _ua =
    global.navigator.userAgent || global.navigator.vendor || global.opera
  return _ua.indexOf('FBAN') > -1 || _ua.indexOf('FBAV') > -1
}

export let isLineApp = function () {
  return ua.indexOf('line') > -1
}

export let isSafari = function () {
  let safari = /version\/[\d\.]+.*safari/.test(ua)
  return !isMobileChrome() && safari
}

export let isIE = function () {
  let _ua = global.navigator.userAgent
  let msie = _ua.indexOf('MSIE ')
  if (msie > -1) {
    return parseInt(_ua.substring(msie + 5, _ua.indexOf('.', msie)), 10)
  }

  let trident = _ua.indexOf('Trident/')
  if (trident > -1) {
    let rv = _ua.indexOf('rv:')
    return parseInt(_ua.substring(rv + 3, _ua.indexOf('.', rv)), 10)
  }

  let edge = _ua.indexOf('Edge/')
  if (edge > -1) {
    return parseInt(_ua.substring(edge + 5, _ua.indexOf('.', edge)), 10)
  }

  return 0
}

export const getViewWidth = function () {
  return (
    window.innerWidth ||
    document.body.clientWidth ||
    document.documentElement.clientWidth
  )
}

export const getViewHeight = function () {
  return (
    window.innerHeight ||
    document.body.clientHeight ||
    document.documentElement.clientHeight
  )
}

export const deviceDirectionPortrait = function () {
  let width = getViewWidth()
  let height = getViewHeight()
  return width / height < 1
}
